import { createApi } from '@reduxjs/toolkit/dist/query/react';
import api from '../lib/axios/api';
import { MsilMicroService } from './microServices';

export default createApi({
  reducerPath: 'msil',
  baseQuery: api(MsilMicroService),
  endpoints: () => ({}),
   tagTypes: ['STATIONS'],
});
